module.exports = __webpack_public_path__ + "media/2.aab1aff5.mp3";